import axios, { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { MovimientoContable } from "../models/consultaMovimientoContable";
import { FiltroMovimientosContables } from "../page/consultarMovimientosContables";

 const getArchivo = async (movimiento: MovimientoContable[]) => {
     const response: AxiosResponse = await axiosInstance.post('siscred-api-reportes/v1/archivo-externo/generar', movimiento, {
    });
          return response;

};

const getMovimientosContables = async (data: FiltroMovimientosContables) => {
    const response: AxiosResponse = await axiosInstance.get('siscred-api-reportes/v1/movimiento-contable/listar', {
        params: data,
    });
    return response;
};

export {
    getArchivo,
    getMovimientosContables
}